import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5e322982&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=5e322982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e322982",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/projects/tus-cc-auth/tus-cc-auth/frontend/tusauth/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VImg,VLayout})
